import { Barrio } from './../../_model/';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { config } from "environments/config";
@Injectable({
  providedIn: 'root'
})
export class BarrioService {

    constructor(private http: HttpClient) {}

    getListBarrio() {
        return this.http
            .get<any>(`${config.apiUrl}/barrio/listar`)
            .toPromise()
            .then((res) => <Barrio[]>res.data)
            .then((data) => {
                return data;
            });
    }

}
